import { classNames } from "helpers";
import Tooltip from "ui/components/Tooltip/Tooltip";
import { DeltaBadge } from "ui/modules/dashboard/pages/DashboardPage/components/common/CardHeader";
import Sparkline from "../Sparkline/Sparkline";
import { buildKpiCards, isPercentagePointMetric } from "./consts";
import { KpiRowProps } from "./types";

const KpiRow: React.FC<KpiRowProps> = ({ summary }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3">
    {buildKpiCards(summary).map((card) => (
      <div key={card.label} className="rounded-sm ring-1 ring-slate-200 bg-white px-4 py-3">
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0">
            <div className="text-xs uppercase text-slate-400 font-semibold">
              {card.label}
            </div>
            <div className="text-xs text-slate-500 truncate">{card.description}</div>
          </div>
          <Tooltip icon="?" size="medium" position="bottom-left">
            <div className="min-w-[220px] max-w-[280px]">
              <div className="font-medium mb-1">{card.label}</div>
              <div className="text-sm text-slate-300">{card.explanation}</div>
            </div>
          </Tooltip>
        </div>

        <div className="flex items-end justify-between gap-3 mt-2">
          <div className="min-w-0">
            <div className={classNames("text-2xl font-semibold", card.valueClass)}>
              {card.value}
            </div>
            <div className="flex items-center gap-1.5 mt-1">
              {card.change !== null && (
                <DeltaBadge
                  value={card.change}
                  inverted={card.inverted}
                  unit={isPercentagePointMetric(card.label) ? " pp" : "%"}
                />
              )}
              <span className="text-[11px] text-slate-400 truncate">
                {card.change === null ? "nema usporedbe" : "vs prethodno razdoblje"}
              </span>
            </div>
          </div>

          <div className="h-10 w-24 shrink-0">
            <Sparkline
              points={card.points}
              hex={card.hex}
              formatValue={card.formatValue}
            />
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default KpiRow;
